class BasketCleaner {
    constructor(button, content) {
        this.opener = button;
        this.content = content;

        this.confirmButton = content.querySelector('[data-confirm-button]');
        this.cancelButton = content.querySelector('[data-cancel-button]');

        this.body = document.querySelector('body');

        this.bind();
    }

    bind() {
        const instance = this;
        this.opener.addEventListener('click', (e) => {
            e.preventDefault();
            instance.open();
        });

        this.cancelButton.addEventListener('click', (e) => {
            e.preventDefault();
            instance.close();
        });

        this.confirmButton.addEventListener('click', (e) => {
            e.preventDefault();
            instance.confirm();
        })
    }

    open() {
        this.content.classList.add('_open');
        // this.body.classList.add('_fixed');
    }

    close() {
        this.content.classList.remove('_open');
        // this.body.classList.remove('_fixed');
    }

    confirm() {
        const csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content');
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const url = this.confirmButton.getAttribute('href');
        const jax = new Jax(
            url,
            'DELETE',
            true
        );
        const data = {[csrfParam]: csrfToken};
        jax.send(data).then((response) => {
            location.reload();
        });
    }

}

function basketBinds() {
}

document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('[data-clear-basket-button]');
    const content = document.querySelector('[data-remove-basket]');
    if (button && content) {
        new BasketCleaner(button, content);
    }
});